import * as z from 'zod';

import { TaskId } from '../BrandedIds';
import { zodDateOrString } from '../utils/Zod';

export const LoanDocumentMailedViaApi = z.object({
  method: z.literal('mailedViaApi'),
  date: zodDateOrString,
  testMode: z.boolean().optional(),
});
export type LoanDocumentMailedViaApi = z.infer<typeof LoanDocumentMailedViaApi>;

export const LoanDocumentAddedToMailTask = z.object({
  method: z.literal('addedToMailTask'),
  date: zodDateOrString,
  taskId: TaskId,
});
export type LoanDocumentAddedToMailTask = z.infer<typeof LoanDocumentAddedToMailTask>;

export const LoanDocumentMailStatus = z.discriminatedUnion('method', [
  LoanDocumentMailedViaApi,
  LoanDocumentAddedToMailTask,
]);
export type LoanDocumentMailStatus = z.infer<typeof LoanDocumentMailStatus>;
